import { UserInfo } from '@user/userInfo';
import { createSafeRegExp, getFromSessionStorage, setSessionStorageItem } from '../tools/basic-functions.js';
import { initHomepageSlider } from './../homepage-slider/homepage-slider';
import { getAllGames, getFavoriteGamesCollections, getGamesCollections } from './get-all-games';
import { initGameWindowMobile } from './mobile/game-window/game-window';
var activeFiltersObject = new Object();
var gamesToLoad = [];
var scrollTopAmount = 0;
window['scrollTopAmount'] = scrollTopAmount;
var maintenanceElementString = document.querySelector('.games-maintenance-mode')
  ? '<div class="maintenance"><div class="maintenance-label">' +
    document.querySelector('.games-maintenance-mode').getAttribute('data-label') +
    '</div></div>'
  : '<div class="maintenance"><div class="maintenance-label">Maintenance</div></div>';
export function initGames() {
  asyncInitGames();
  initGamesFilters();
}

export async function initGamesList() {
  let gamesListEl = document.querySelector('.games-list'),
    gamesListIds = gamesListEl.getAttribute('games-list-ids').split(',');
  for (let i = 0; i < gamesListIds.length; i++) gamesListIds[i] = parseInt(gamesListIds[i], 10);
  let gamesObj = await getAllGames(),
    gamesList = filterGamesByIdsList(gamesObj, gamesListIds);
  await createGames(gamesList, gamesListEl.getAttribute('data-games'));
  if (!_CMS_MOBILE && gamesListEl.classList.contains('swiper-container')) {
    addSwiperSlideClass(gamesListEl.getAttribute('data-games'));
    initHomepageSlider(null, gamesListEl);
  }
  afterGamesInit();
}

export async function initGamesSearch() {
  var gamesObj = await getAllGames();
  //await createGamesPanels(gamesObj);
  showInitialGames(gamesObj);
  initGamesSearchInput(gamesObj);
  initGamesTournaments();
}

async function asyncInitGames() {
  let gameProvidersEl = document.querySelectorAll('.games.games-operators:not(.modal-games)'),
    gamesList = document.querySelectorAll('.games:not(.games-operators):not(.modal-games)');
  if (gamesList.length > 1) {
    const gamesCollections = await getGamesCollections(),
      allGames = await getAllGames(),
      lazyModule = await import('../tools/lazyload');
    let lazyCollection = [];
    for (var i = 0, len = gamesList.length; i < len; i++) {
      if (i < 6)
        await getGamesToCarousel(gamesList[i].getAttribute('data-games'), gamesCollections, allGames, gamesList[i]);
      else {
        lazyCollection.push(gamesList[i]);
        for (const gameThumb of gamesList[i].querySelectorAll('.game-thumb')) {
          gameThumb.classList.add('loading');
        }
      }
    }
    if (lazyCollection.length !== 0) lazyModule.addCollection(lazyCollection);
  } else if (gamesList.length == 1 && !gamesList[0].getAttribute('games-list-ids')) {
    await getGames(gamesList[0].getAttribute('data-games'));
  }
  afterGamesInit();
  if (_CMS_MOBILE) {
    initGameWindowMobile();
    initGameModePopupCloseButton();
    initGameModePopupGameImageButton();
  }
  initAnimatedGamesThumbs();
  if (gameProvidersEl && !_CMS_MOBILE) {
    for (const gameProviderEl of gameProvidersEl) initHomepageSlider(null, gameProviderEl);
  }
}

/* 
    IF THE PAGE CONTAINS MORE THAN 6 COLLECTIONS,
    ONLY THE FIRST 6 WILL BE LOADED,
    BUT THE EVENT WILL BE EXECUTED
*/

async function afterGamesInit() {
  const { initGamesJackpots } = await import('./modules/jackpots');
  const { initGamesFavourites } = await import('./modules/favourite');

  initGamesMaintenance(); // ?
  initGamesJackpots(); // ok
  initLiveCasinoApi(); // ok?
  initGamesFavourites();
}

async function getGames(category) {
  const moduleBasicFunc = await import('../tools/basic-functions.js');
  let gamesObj = await getAllGames(),
    gamesCollections = await getGamesCollections();
  if (category == 'casino-games') {
    await createGames(gamesObj, category);
  } else if (category == 'favorite-games') {
    initFavoriteGames(gamesObj, category);
  } else if (category == 'module-favorite-games') {
    initFavoriteGames(gamesObj, category);
  } else if (category == 'selected-games') {
    initSelectedGames(gamesObj);
  } else if (category != 'recommended-games') {
    var gamesList,
      collectionCode = category.split(' ')[1],
      collectionCode = collectionCode == 'new' ? 'new-games' : collectionCode, //TEMP collection code not equal category
      gameCollection = gamesCollections.find((t) => t.code === collectionCode || t.master_code === collectionCode),
      order = gameCollection ? gameCollection.items : '';
    if (order != '') {
      const { removeGamesIfNotInArray } = await import('./utilities');
      gamesList = removeGamesIfNotInArray(gamesObj, order);
      gamesList = moduleBasicFunc.arrayOrder(gamesList, order, 'id');
    } else {
      const { filterGames } = await import('./utilities');
      gamesList = filterGames(gamesObj, category);
    }
    await createGames(gamesList, category);
  }
}

export async function getGamesToCarousel(slideCategory, gamesCollections, allGames, sliderEl) {
  const moduleBasicFunc = await import('../tools/basic-functions.js'),
    gameCollection = await (async () => {
      switch (slideCategory) {
        case 'last-played': {
          const { getLastPlayedOrRecommendedGames } = await import('./collections');
          return await getLastPlayedOrRecommendedGames(allGames);
        }
        case 'selected-games': {
          const { getSelectedGames } = await import('./get-all-games');
          return await getSelectedGames();
        }
        case 'favorite-games':
        case 'module-favorite-games': {
          return await getFavoriteGamesCollections();
        }
        default: {
          return gamesCollections.find((t) => t.code === slideCategory || t.master_code === slideCategory);
        }
      }
    })();
  const order = gameCollection ? gameCollection.items : '';
  if (order) {
    const { removeGamesIfNotInArray } = await import('./utilities');
    let gamesList =
      slideCategory == 'selected-games'
        ? removeGamesIfNotInArraySortDefault(allGames, order)
        : removeGamesIfNotInArray(allGames, order);
    const isModalGames = sliderEl ? sliderEl.classList.contains('modal-games') : false;
    if (
      slideCategory == 'favorite-games' ||
      slideCategory == 'module-favorite-games' ||
      slideCategory == 'last-played' ||
      slideCategory == 'selected-games'
    ) {
      if (
        ((slideCategory == 'favorite-games' || slideCategory == 'selected-games') &&
          ((gamesList.length < 6 && !isModalGames) || gamesList.length < 1)) ||
        (slideCategory == 'last-played' && gamesList.length < 1)
      )
        return false;
      else {
        const categoryGamesWrapper = sliderEl || document.querySelector(`.games[data-games="${slideCategory}"]`);
        if (gamesList.length > 0) categoryGamesWrapper.classList.remove('d-none');
      }
    }
    appendGamesHeaderQuantity(gamesList.length, slideCategory);
    gamesList = moduleBasicFunc.arrayOrder(gamesList, order, 'id').slice(0, 25);
    await createGames(gamesList, slideCategory, false, isModalGames);
    await addMoreButton(slideCategory);
    if (!_CMS_MOBILE) {
      addSwiperSlideClass(slideCategory);
      initHomepageSlider(slideCategory, sliderEl);
    }
  }
}

/**
 * Append games Wrapper
 * @param {Array} gamesList games list
 * @param {String} datagames attribute
 * @param {boolean} isRecommendedGames flag to change gamesWrapper to recommended-games
 */
export async function createGames(gamesList, gamesWraperAttr, isRecommendedGames, isModalGames) {
  const { createGameElement, addGameElementMobileEvent } = await import('./modules/game-element');
  const gamesWrapperList = !isRecommendedGames
    ? document.querySelectorAll(
        `${isModalGames ? '.modal-games' : ''}.games[data-games="${gamesWraperAttr}"] .games-body`
      )
    : document.querySelectorAll('.recommended-games .games-body');
  for (let gamesWrapper of gamesWrapperList) {
    if (isModalGames && isRecommendedGames) {
      gamesWrapper = document.querySelector('.recommended-games.modal-games .games-body');
    }
    gamesWrapper.setAttribute('status', 'initialized');
    const newGamesElementsList = [];
    for (var i = 0, len = gamesList.length; i < len && i < 180; i++) {
      var item = gamesList[i];
      if (!item) break;
      if (item.id) {
        /*var gameElement = !isRecommendedGames
          ? await createGameElement(item)
          : await createRecommendedGameElement(item, justLinks);*/
        const gameElement = await createGameElement(item);
        //gamesWrapper.appendChild(gameElement);
        newGamesElementsList.push(gameElement);
        if (_CMS_MOBILE) addGameElementMobileEvent(gameElement);
        else initRunGameClickEvent(gameElement);

        //TODO na desktop po włączeniu gier niech będzie pushstate z urlem gry. potem popstate z kliknięciem wstecza
        //po kliknięciu kółkiem niech się otwiera opis gry w nowej karcie
      }
    }

    gamesWrapper.innerHTML = '';
    for (const newGamesElement of newGamesElementsList) {
      gamesWrapper.appendChild(newGamesElement);
    }

    if (gamesWraperAttr == 'casino-games') {
      document.querySelector('.load-more-games-wrapper').classList.remove('d-none');
      var loadMoreGamesBtn = document.querySelector('.js-load-more-games');
      loadMoreGamesBtn.addEventListener('click', async () => {
        loadMoreGamesBtn.classList.add('loading');
        setTimeout(async () => {
          await loadAllGamesWithFilters(gamesWrapper);
          loadMoreGamesBtn.classList.remove('loading');
        }, 50);
      });
    }
    if (gamesWraperAttr == 'last-played') {
      gamesWrapper.classList.remove('d-none');
    }
    gamesWrapper.setAttribute('status', 'during');
  }
}

async function addMoreButton(gamesWrapperAttr) {
  const moduleTranslations = await import('../tools/translations.js');
  const gamesWrapper = document.querySelector('.games[data-games="' + gamesWrapperAttr + '"] .games-body');
  const btn = gamesWrapper.parentNode.querySelector('.btn-all');
  const title = gamesWrapper.parentNode.querySelector('a.title');
  if (!btn || !title) return;
  btn?.addEventListener('click', (e) => {
    if (e.which == 1 || e.button == 0) title.click();
  });
  btn?.addEventListener('contextmenu', () => {
    btn.style['pointer-events'] = 'none';
    setTimeout(() => {
      btn.style['pointer-events'] = null;
    }, 50);
  });
  if (!gamesWrapper.parentElement.classList.contains('modal-games')) {
    const link = title?.getAttribute('href'),
      moreTranslation = await moduleTranslations.getTranslation('more'),
      domString =
        '<div class="game game-lastItem"><span class="game-link ' +
        _CMS_LANGUAGE +
        '"><a href="' +
        link +
        '">' +
        moreTranslation +
        '</a></span><div class="game-thumb"></div></div>';
    const html = new DOMParser().parseFromString(domString, 'text/html');
    const gameElement = html.body.firstChild;
    gamesWrapper.appendChild(gameElement);
  }
}

function addSwiperSlideClass(gamesWrapperAttr) {
  let gamesList = document.querySelectorAll('.games[data-games="' + gamesWrapperAttr + '"] .games-body .game');
  for (let i = 0, len = gamesList.length; i < len; i++) {
    gamesList[i].classList.add('swiper-slide');
  }
}

export async function getTournamentForGame(gameId) {
  const userInfoInstance = new UserInfo();
  const isLogged = await userInfoInstance.isLoggedAsync();
  if (!isLogged) {
    return null;
  }

  const { getTournamentJson } = await import('./data');
  const tournaments = await getTournamentJson();
  if (!tournaments) return null;

  for (let tournament of tournaments) {
    if (tournament.games.includes(parseInt(gameId))) {
      return tournament;
    }
  }
  return null;
}

export async function getTournamentIdForGame(gameId) {
  const { id } = (await getTournamentForGame(gameId)) || {};
  return id;
}

export async function getTournamentDataCMS(tournamentId) {
  if (_CMS_USER_SESSION_ACTIVE != '1') return null;
  const { getTournamentJsonCMS } = await import('./data');
  const { data } = await getTournamentJsonCMS(tournamentId);
  if (!data) return null;

  return data;
}

export async function initGamesTournaments() {
  const userInfoInstance = new UserInfo();
  const isLogged = await userInfoInstance.isLoggedAsync();
  if (!isLogged) {
    return;
  }

  const { getTournamentJson } = await import('./data');
  let tournaments = await getTournamentJson();

  if (!tournaments || !Array.isArray(tournaments)) {
    return;
  }

  for (const tournament of tournaments) {
    const tournamentId = tournament.id;
    const tournamentGames = tournament.games;

    if (!tournamentGames || !Array.isArray(tournamentGames)) {
      continue;
    }

    for (const tournamentGame of tournamentGames) {
      const gameEl = document.querySelector('.game[data-game-id="' + tournamentGame + '"]');

      if (!gameEl) {
        continue;
      }

      gameEl.setAttribute('data-tournament-id', tournamentId);
      gameEl.classList.add('js-tournament');
    }
  }
}

async function initLiveCasinoApi() {
  const { getLiveCasinoApi } = await import('./data');
  const liveCasinoApi = await getLiveCasinoApi();
  if (!liveCasinoApi || !Array.isArray(liveCasinoApi)) {
    return;
  }

  let hasLive = false;

  for (const liveCasinoItem of liveCasinoApi) {
    if (liveCasinoItem && liveCasinoItem.GameId) {
      const gameElList = document.querySelectorAll('.game[data-game-id="' + liveCasinoItem.GameId + '"]');

      for (const gameEl of gameElList) {
        initLiveCasinoGame(gameEl, true);
        hasLive = true;
      }
    }
  }
  if (!hasLive) gamesThumbnailsLoadedEvent();
}

export function initLiveCasinoGame(gameEl, bypass = false) {
  if (!gameEl || gameEl.classList.contains('is-live-api')) return;
  if (!bypass && !window['tables-live']) return;
  const liveGameID = gameEl.getAttribute('data-game-id');
  const removeFromList = () => {
    gamesToLoad = gamesToLoad.filter((gameId) => gameId !== liveGameID);
    if (gamesToLoad.length === 0) gamesThumbnailsLoadedEvent();
  };
  if (!gamesToLoad.find((gameId) => gameId === liveGameID)) {
    gamesToLoad.push(liveGameID);
  }
  setTimeout(async () => {
    if (!bypass) {
      if (!liveGameID) {
        removeFromList();
        return;
      }
      const { getLiveCasinoApi } = await import('./data');
      const liveCasinoApi = await getLiveCasinoApi();
      if (!liveCasinoApi || !Array.isArray(liveCasinoApi)) {
        return;
      }
      const liveCasinoGame = liveCasinoApi.filter(({ GameId }) => GameId == liveGameID).slice(-1)[0];
      if (!liveCasinoGame) {
        removeFromList();
        return;
      }
    }
    gameEl.append(createEL('<div class="game-item-api js-bo-api-details live-api"></div>'));
    gameEl.append(createEL('<div class="game-item-api js-bo-api-stake live-api"></div>'));
    gameEl.classList.add('is-live-api');
    removeFromList();
  }, 200);
}

export async function initGamesSearchInput(gamesList, gameWindow) {
  const moduleBasicFunc = await import('../tools/basic-functions.js');
  const { addGameElementMobileEvent } = await import('./modules/game-element');

  let searchContainer = gameWindow
    ? document.querySelector('.modal-game-mode-popup .modals')
    : document.querySelector('.modal-search');
  var searchInput = searchContainer.querySelector('.search-input');
  const panelsBody =
    gameWindow && _CMS_MOBILE
      ? searchContainer.querySelector('.search-games')
      : searchContainer.querySelector('.panels-body');
  const panels =
    gameWindow && _CMS_MOBILE
      ? panelsBody.closest('.modal-wrapper').querySelector('.modal-footer')
      : panelsBody.parentNode;
  const { getTranslation } = await import('../tools/translations');
  const loadMoreText = await getTranslation('load_more_games');
  const loadMore = createEL(
    `<button class="btn ${
      !gameWindow || !_CMS_MOBILE
        ? `btn-size-full btn-outline-green btn-${_CMS_MOBILE ? 'xl' : 'lg'}  btn-radius-md
    `
        : ''
    } btn-load-more d-none">${loadMoreText}</button>`
  );
  panels.appendChild(loadMore);
  const loadSearchGames = async (count) => {
    loadMore.classList.add('d-none');
    let searchInputValue = searchInput.value;
    if (searchInputValue.length > 2) {
      if (gameWindow && _CMS_MOBILE) {
        searchContainer.querySelector('.initial-games').classList.remove('active');
      }
      searchInputValue = searchInputValue
        .toLowerCase()
        .replace(/[\*\^\'\!\:]/g, '')
        .split(' ')
        .join('-');
      panelsBody.innerHTML = '';
      let loadedGames = 0,
        availableGames = 0;
      const { createGameElement, createGamePanel } = await import('./modules/game-element');
      for (let i = 0; i < gamesList.length; i++) {
        const game = gamesList[i];
        if (
          game.name
            .toLowerCase()
            .replace(/[\*\^\'\!\™\:]/g, '')
            .split(' ')
            .join('-')
            .search(createSafeRegExp(searchInputValue)) > -1 ||
          game.provider
            .toLowerCase()
            .replace(/[\*\^\'\!\™\:]/g, '')
            .split(' ')
            .join('-')
            .search(createSafeRegExp(searchInputValue)) > -1
        ) {
          availableGames++;
          if (!count || loadedGames < count) {
            loadedGames++;
            if (gameWindow && _CMS_MOBILE) {
              const gameElement = await createGameElement(game);
              addGameElementMobileEvent(gameElement);
              panelsBody.appendChild(gameElement);
            } else {
              await createGamePanel(game, gameWindow);
            }
          }
        }
      }
      if (count && availableGames > count) {
        loadMore.classList.remove('d-none');
      }
    } else {
      await showInitialGames(gamesList, gameWindow);
    }
  };
  loadMore.addEventListener('click', () => {
    loadSearchGames();
  });
  searchInput.addEventListener('input', () => {
    loadSearchGames(12);
    initGamesTournaments();
  });
  var searchInputClear = searchContainer.querySelector('.js-clear');
  searchInputClear.addEventListener('click', async () => {
    if (searchInput.value.length == 0) {
      if (!!document.querySelector('.modal-search .btn-back')) {
        moduleBasicFunc.simulateClick(document.querySelector('.modal-search .btn-back'));
      } else {
        moduleBasicFunc.simulateClick(document.querySelector('.js-game-back-button'));
      }
      return false;
    }
    searchInput.value = '';
    await showInitialGames(gamesList, gameWindow);
    initGamesTournaments();
  });
  var searchTags = searchContainer.querySelectorAll('.js-search-tag');
  for (var i = 0, len = searchTags.length; i < len; i++) {
    searchTags[i].addEventListener('click', (e) => {
      initSearchTag(e.currentTarget);
    });
  }
  if (_CMS_MOBILE) {
    const moduleBasicFunctions = await import('../tools/basic-functions.js');
    const gameWindowEl = document.querySelector('.modal-game-mode-popup');
    document.querySelector('.modal-game-mode-popup .modals')?.addEventListener('click', (e) => {
      if (e.target?.closest('.js-game-popup')) {
        setTimeout(() => {
          moduleBasicFunctions.simulateClick(gameWindowEl.querySelector('.js-game-back-button'));
          moduleBasicFunctions.simulateClick(gameWindowEl.querySelector('.close'));
        }, 100);
      }
    });
  }
}
/**
 * Fills search input with a search tag value
 */

function initSearchTag(tag) {
  var searchInput = document.querySelector('.search-input');
  searchInput.value = tag.innerText;
  var event = new Event('input', {
    bubbles: true,
    cancelable: true
  });
  searchInput.dispatchEvent(event);
}

/**
 * Populates the game window with the initial set of games in the provided games list.
 * @param {Array} gamesList - The list of games to display.
 * @param {Boolean} gameWindow - Whether the game window is open or not.
 * @returns {Promise<void>}
 */
async function showInitialGames(gamesList, gameWindow) {
  const { createGamePanel } = await import('./modules/game-element');

  const container = gameWindow
    ? document.querySelector('.modal-game-mode-popup .modals')
    : document.querySelector('.search-games');

  const body =
    gameWindow && _CMS_MOBILE ? container.querySelector('.search-games') : container.querySelector('.panels-body');

  body.innerHTML = '';
  if (gameWindow && _CMS_MOBILE) {
    container.querySelector('.initial-games').classList.add('active');
    container.querySelector('.btn-load-more').classList.add('d-none');
    return;
  }
  const gamesToCreate = gamesList.slice(0, 10).filter((game) => {
    return game.id && !container.contains(document.querySelector(`[data-game-id="${game.id}"]`));
  });
  for (const game of gamesToCreate) {
    await createGamePanel(game, gameWindow);
  }
}

/**
 * Return list of games based on collection json
 * @param {Object} allGames object with all games
 * @param {Array} carouselList list with games ids
 * @returns {Array} list of games
 */
export function removeGamesIfNotInArraySortDefault(allGames, carouselList) {
  try {
    const gamesMap = new Map(allGames.map((game) => [game.id, game]));

    const result = [];
    for (const id of carouselList) {
      if (gamesMap.has(id)) {
        result.push(gamesMap.get(id));
      }
    }

    return result;
  } catch (error) {
    console.error('An error occurred:', error);
    return [];
  }
}

/**
 * Return list of games based on ids list
 * @param {Object} allGames object with all games
 * @param {String} gamesIdsList category from data-games
 * @returns {Array} list of games
 */
export function filterGamesByIdsList(allGames, gamesIdsList) {
  let gamesList = [];
  for (let i = 0; i < gamesIdsList.length; i++) gamesIdsList[i] = parseInt(gamesIdsList[i], 10);
  for (let i = 0, len = allGames.length; i < len; i++) {
    let game = allGames[i];
    if (game.id) {
      if (gamesIdsList.includes(game.id)) {
        gamesList.push(game);
      }
    }
  }
  return gamesList;
}

function initGamesMaintenance() {
  if (document.querySelectorAll('.game').length > 0) {
    var gamesMaintenanceModeConfigsList = document.querySelectorAll('.games-maintenance-mode');
    for (var i = 0, len = gamesMaintenanceModeConfigsList.length; i < len; i++) {
      var gamesMaintenanceModeConfig = gamesMaintenanceModeConfigsList[i];
      var min = parseInt(gamesMaintenanceModeConfig.getAttribute('data-min'));
      var max = parseInt(gamesMaintenanceModeConfig.getAttribute('data-max'));
      var list = gamesMaintenanceModeConfig.getAttribute('data-ids-list');
      var gamesList = document.querySelectorAll('.game:not(.btn)');
      if (list) {
        list = list.split(',').map(Number);
        for (var j = 0, lenJ = gamesList.length; j < lenJ; j++) {
          var game = gamesList[j];
          if (list.includes(parseInt(game.getAttribute('data-game-id')))) {
            if (!game.classList.contains('maintenance')) {
              game.prepend(createEL(maintenanceElementString));
            }
            game.classList.add('maintenance');
            game.classList.remove('js-run-game');
          }
        }
      } else {
        for (var j = 0, lenJ = gamesList.length; j < lenJ; j++) {
          var game = gamesList[j];
          if (
            parseInt(game.getAttribute('data-game-id')) >= min &&
            parseInt(game.getAttribute('data-game-id')) <= max
          ) {
            if (!game.classList.contains('maintenance')) {
              game.prepend(createEL(maintenanceElementString));
            }
            game.classList.add('maintenance');
            game.classList.remove('js-run-game');
          }
        }
      }
    }
  }
}

async function initGameModePopupCloseButton() {
  const module = await import('../tools/basic-functions.js');
  module.click('.modal-game-description .js-back, .modal-game-description .js-close', closeGameModePopup);
  window.onpopstate = () => {
    document.querySelector('.js-game-mode-popup').classList.remove('active');
    document.body.classList.remove('game-mode-popup-open');
    window.scrollTo({ top: scrollTopAmount });
    document.querySelector('.alerts').innerHTML = '';
  };
}

function closeGameModePopup() {
  document.querySelector('.js-game-mode-popup').classList.remove('active');
  document.body.classList.remove('game-mode-popup-open');
  window.scrollTo({ top: scrollTopAmount });
  document.querySelector('.alerts').innerHTML = '';
  //history.back();
}

async function initGameModePopupGameImageButton() {
  const moduleBasicFunc = await import('../tools/basic-functions.js');
  let gamePopupNode = document.querySelector('.js-game-mode-popup');
  gamePopupNode.querySelector('.game-movie').addEventListener('click', () => {
    moduleBasicFunc.simulateClick(gamePopupNode.querySelector('.mobile-game-real'));
  });
}

export function initMobileRunGameClickEvent() {
  let gamePopupNode = document.querySelector('.js-game-mode-popup');
  const gameModeSwitch = document.querySelector('.gamepopup .game-mode-switch');
  if (gameModeSwitch) {
    gameModeSwitch.addEventListener('click', () => {
      gamePopupNode.querySelector('.mobile-game-real').click();
    });
  }

  if (!gamePopupNode) {
    return;
  }
  let gameBtns = gamePopupNode.querySelectorAll('.mobile-game-real, .mobile-game-demo'),
    modalGameElement = document.querySelector('.gamepopup .modal-game-mode-popup');
  for (let i = 0, len = gameBtns.length; i < len; i++) {
    let btn = gameBtns[i];
    btn.addEventListener('click', (e) => {
      e.currentTarget.classList.add('loading');
      const gameId = gamePopupNode.getAttribute('data-game-id');
      modalGameElement.setAttribute('data-game-id', gameId);

      if (gameModeSwitch) {
        gameModeSwitch.classList.toggle('d-none', btn.classList.contains('mobile-game-real'));
      }
    });
  }
  document.addEventListener('GAME_START', () => {
    gamePopupNode.querySelector('.mobile-game-real').classList.remove('loading');
    gamePopupNode.querySelector('.mobile-game-demo').classList.remove('loading');
  });
}

export async function initRunGameClickEvent(game) {
  const gameId = game.getAttribute('data-game-id');
  game.querySelector('.game-title')?.addEventListener('click', (e) => {
    e.stopPropagation();
  });

  game.querySelector('.js-run-demo')?.addEventListener('click', async () => {
    const { runGameClickEventHandler } = await import('./desktop/game-window/game-window');
    runGameClickEventHandler(gameId, true);
  });
}

export async function initRunGameClickEventHandlerMobile() {
  document.addEventListener('GAME_START', async (e) => {
    const { initGameModePopupHandlerReal } = await import('./mobile/game-window/game-window');
    initGameModePopupHandlerReal(e);
    const gameId = e.detail.gameId;
    const gamePopupNode = document.querySelector('.js-game-mode-popup');
    const modalGameElement = document.querySelector('.gamepopup .modal-game-mode-popup');
    if (gameId == gamePopupNode.getAttribute('data-game-id')) {
      return;
    }
    const { initGameModePopupHandler } = await import('./mobile/game-window/game-window');
    initGameModePopupHandler(gameId, false);
    modalGameElement.setAttribute('data-game-id', gameId);
  });

  document.addEventListener('GAME_END', async () => {
    const { stopGameModePopupHandler } = await import('./mobile/game-window/game-window');
    stopGameModePopupHandler();
  });
}

export async function initRunGameClickEventHandler() {
  document.addEventListener('GAME_START', async (e) => {
    const { runGameClickEventHandler } = await import('./desktop/game-window/game-window');
    runGameClickEventHandler(e.detail.gameId);
  });

  document.addEventListener('GAME_END', async () => {
    const { stopGameEventHandler } = await import('./desktop/game-window/game-window');
    stopGameEventHandler();
  });
}

export async function initStopGameEventHandler() {
  document.addEventListener('GAME_END', async () => {
    const { destroyGameWindow } = await import('./desktop/game-window/destroy-game-window');
    destroyGameWindow();
  });
}

export async function initMobileStopGameEventHandler() {
  document.addEventListener('GAME_END', async () => {
    const { destroyGameWindow } = await import('./mobile/game-window/destroy-game-window');
    destroyGameWindow();
  });
}

async function initFavoriteGames(allGames, category = 'favorite-games') {
  if (_CMS_USER_SESSION_ACTIVE != '1') return;
  const favourites = (await getFavoriteGamesCollections())?.items || [];
  if (!Array.isArray(favourites)) return;
  const favouriteGames = removeGamesIfNotInArraySortDefault(allGames, favourites);
  createGames(favouriteGames, category);
}

async function initSelectedGames(allGames) {
  if (_CMS_USER_SESSION_ACTIVE != '1') return;
  const { getSelectedGames } = await import('./get-all-games');
  let selectedGames = (await getSelectedGames()) || {};
  if (selectedGames.items) selectedGames = selectedGames.items;
  if (!Array.isArray(selectedGames)) return;
  let gamesList = removeGamesIfNotInArraySortDefault(allGames, selectedGames);
  createGames(gamesList, 'selected-games');
}

export function countFiltersBodyHeight() {
  let filtersHeadersList = document.querySelectorAll('.js-filter-header'),
    filtersBodyHeight = document.querySelector('.filters').getAttribute('data-device') == 'web' ? 43 : 70;
  for (let i = 0, len = filtersHeadersList.length; i < len; i++) {
    filtersHeadersList[i].parentNode.querySelector('.filter-body').classList.add('loading');
    filtersHeadersList[i].parentNode.querySelector('.filter-body').style.maxHeight = '1000px';
    let height = filtersHeadersList[i].parentNode.querySelector('.filter-body').clientHeight;
    //if one row
    if (height <= filtersBodyHeight) {
      filtersHeadersList[i].parentNode.classList.add('active');
    }
    filtersHeadersList[i].setAttribute('data-height', height);
    filtersHeadersList[i].parentNode.querySelector('.filter-body').style.maxHeight = filtersBodyHeight + 'px';
    filtersHeadersList[i].parentNode.querySelector('.filter-body').style.opacity = '1';
    setTimeout(() => filtersHeadersList[i].parentNode.querySelector('.filter-body').classList.remove('loading'), 10);
  }
}

async function initGamesFilters() {
  if (document.querySelectorAll('.filter .btn-filter').length > 0) {
    countFiltersBodyHeight();
    const module = await import('../tools/basic-functions.js');
    var filterBtnsList = document.querySelectorAll('.btn-filter');
    for (var i = 0, len = filterBtnsList.length; i < len; i++) {
      var filterType = filterBtnsList[i].getAttribute('data-filter-type');
      if (!activeFiltersObject.hasOwnProperty(filterType)) {
        activeFiltersObject[filterType] = [];
      }
    }
    module.click('.btn-filter', gamesFilters);
    module.click('.js-filter-header', gamesFiltersCollapse);
  }
}

async function gamesFiltersCollapse(el) {
  const module = await import('../tools/animations.js');
  if (el.parentNode.classList.contains('active')) {
    module.slideUp(el.parentNode.querySelector('.filter-body'));
    el.parentNode.classList.remove('active');
  } else {
    var height = el.getAttribute('data-height');
    module.slideDown(el.parentNode.querySelector('.filter-body'), height);
    el.parentNode.classList.add('active');
  }
}

async function gamesFilters(el) {
  if (!el.classList.contains('view-only')) {
    document.querySelector('.load-more-games-wrapper').classList.add('d-none');
    var gamesWrapper =
      (document.body.getAttribute('data-product-type') == 'live-casino'
        ? document.querySelector('.games[data-games="tags live-casino"] .games-body')
        : document.querySelector('.games[data-games="casino-games"] .games-body')) ||
      document.querySelector('.games[data-games] .games-body');
    gamesWrapper.innerHTML = '<div class="loader icon icon-spinner-l-g"></div>';
    el.classList.toggle('active');
    var filterType = el.getAttribute('data-filter-type');
    if (el.classList.contains('active')) {
      activeFiltersObject[filterType].push(el.getAttribute('data-tag'));
    } else {
      var indexToRemove = activeFiltersObject[filterType].indexOf(el.getAttribute('data-tag'));
      activeFiltersObject[filterType].splice(indexToRemove, 1);
    }
    setSessionStorageItem('filtersLoader', {
      activeFiltersObject,
      allGamesCounter: 0
    });
    loadAllGamesWithFilters();
    afterGamesInit();
    initGamesTournaments();
    document.querySelector('.games .loader').remove();
  } else {
    let langLocale = _CMS_LOCALE != '' ? _CMS_LOCALE : _CMS_LANGUAGE;
    if (document.body.getAttribute('data-product-type') == 'live-casino') {
      window.location.href = window.location.origin + '/' + langLocale + '/live-casino/all-games';
    } else {
      window.location.href = window.location.origin + '/' + langLocale + '/casino-games';
    }
  }
}

async function loadAllGamesWithFilters(container = document.querySelector('.games[data-games] .games-body')) {
  const { createGameElement, addGameElementMobileEvent } = await import('./modules/game-element');
  const loadGame = async (game) => {
    const gameElement = await createGameElement(game);
    container.appendChild(gameElement);
    if (_CMS_MOBILE) {
      addGameElementMobileEvent(gameElement);
    } else {
      initRunGameClickEvent(gameElement);
    }
  };
  let games = await getAllGames(),
    allEmpty = Object.keys(activeFiltersObject).every((key) => {
      return activeFiltersObject[key].length === 0;
    }),
    hideLoadMore = false,
    gamesCategory = container.parentElement?.getAttribute('data-games');
  if (gamesCategory?.includes('kind')) {
    const { filterGames } = await import('./utilities');
    games = filterGames(games, gamesCategory);
  }
  if (!allEmpty) {
    let visibleCounter = 0,
      lastGameIndex,
      filtersLoader = getFromSessionStorage('filtersLoader'),
      filtersGames = [],
      filtersCorrect = Object.keys(activeFiltersObject).every((key) => {
        return filtersLoader.activeFiltersObject[key].every((item) => activeFiltersObject[key].includes(item));
      }),
      filtersCounter = (lastGameIndex =
        filtersCorrect && !isNaN(filtersLoader?.allGamesCounter) ? filtersLoader?.allGamesCounter : 0);
    for (let i = filtersCounter, len = games.length; i < len; i++) {
      let game = games[i],
        isVisible = false;
      lastGameIndex = i;
      if (!game) continue;
      if (
        !(document.body.getAttribute('data-product-type') == 'live-casino' && !game['tags'].includes('live-casino'))
      ) {
        for (const key in activeFiltersObject) {
          if (!Object.prototype.hasOwnProperty.call(activeFiltersObject, key)) continue;
          const gameAttributeArray =
            key == 'tags' ? game[key] : game[key].replace(/\s+/g, '-').toLowerCase().split(',');
          isVisible = true;
          if (
            activeFiltersObject[key].length == 0 ||
            activeFiltersObject[key].some((val) => gameAttributeArray.indexOf(val) >= 0)
          )
            continue;
          isVisible = false;
          break;
        }
      }
      if (isVisible) {
        filtersGames.push(game);
      }
      if (filtersGames.length >= 181) break;
    }
    for (const game of filtersGames) {
      if (visibleCounter >= 180) break;
      visibleCounter++;
      await loadGame(game);
    }
    if (filtersGames?.length <= 180) hideLoadMore = true;
    else
      setSessionStorageItem('filtersLoader', {
        activeFiltersObject,
        allGamesCounter: lastGameIndex
      });
  } else {
    const gamesCount = container.querySelectorAll('.game').length;
    for (let i = gamesCount, allGamesLen = games.length, len = gamesCount + 180; i < len && i < allGamesLen; i++) {
      await loadGame(games[i]);
    }
    hideLoadMore = games.length <= container.querySelectorAll('.game').length;
    setSessionStorageItem('filtersLoader', {
      activeFiltersObject,
      allGamesCounter: 0
    });
  }
  const loadMoreClassList = document.querySelector('.load-more-games-wrapper').classList;
  if (!hideLoadMore) {
    loadMoreClassList.remove('d-none');
    return;
  }
  loadMoreClassList.remove('loading');
  loadMoreClassList.add('d-none');
}

async function initAnimatedGamesThumbs() {
  const moduleAnimatedGamesThumbs = await import('./both/animated-game-thumbs/animated-games-thumbs');
  moduleAnimatedGamesThumbs.initAnimatedGamesThumbs();
}

function appendGamesHeaderQuantity(quantity, gamesWraperAttr) {
  let gamesWrapperList = document.querySelectorAll('.games[data-games="' + gamesWraperAttr + '"]');
  for (const gamesWrapper of gamesWrapperList) {
    if (!gamesWrapper.querySelector('.games-header .quantity')) continue;
    gamesWrapper.querySelector('.games-header .quantity').innerHTML = quantity;
  }
}

export async function initRecommendedGames(games) {
  var gamesList = games ? games : await getAllGames();
  const { getRecommendedGames } = await import('./collections');
  var recommendedGames = await getRecommendedGames(gamesList, 20);
  await createGames(recommendedGames, 'recommended', true);
  if (!_CMS_MOBILE) {
    addSwiperSlideClass('recommended-games');
    initHomepageSlider('recommended-games');
  }
}

export async function initGamesDesc() {
  const { initTags, findGameByUrl, checkFavoriteGame } = await import('./utilities');
  const { getTranslation } = await import('../tools/translations');

  var gamesListObj = await getAllGames();
  initRecommendedGames(gamesListObj);
  var gameUrl = getUrlLastSegment(),
    gameObj = findGameByUrl(gamesListObj, gameUrl);
  if (gameObj) {
    let thumbsnailSrc = _CMS_MOBILE ? '/images/uploads/games-thumbs/x175' : '/images/uploads/games-thumbs/x300';
    document.querySelector('.game-bg img').src = thumbsnailSrc + '/' + gameObj.id + '.jpg';

    const { simulateClick, runByLoginControl } = await import('../tools/basic-functions.js');
    const gameIdFavEl = document.querySelector('.game-id');
    if (gameIdFavEl) {
      gameIdFavEl.setAttribute('data-game-id', gameObj.id);
      gameIdFavEl.classList.remove('d-none');
      const isFaved = await checkFavoriteGame(gameObj.id);
      gameIdFavEl.querySelector('.js-favourites')?.classList.toggle('js-faved', isFaved);
    }

    const tournamentId = await getTournamentIdForGame(gameObj.id);

    if (_CMS_MOBILE) {
      const { simulateClick } = await import('../tools/basic-functions');
      document.querySelector('#gameContainer .game-movie').addEventListener('click', () => {
        const modalGameElement = document.querySelector('.modalsGameModePopup .js-game-mode-popup');

        const runGame = async (isLogged) => {
          const jsRunElement = modalGameElement.querySelector(isLogged ? '.mobile-game-real' : '.mobile-game-demo');
          jsRunElement.setAttribute('data-game-id', gameObj.id);

          if (tournamentId) {
            jsRunElement.setAttribute('data-tournament-id', tournamentId);
          } else {
            jsRunElement.removeAttribute('data-tournament-id');
          }

          jsRunElement.classList.toggle('js-tournament', tournamentId);

          setTimeout(() => {
            simulateClick(jsRunElement);
            console.log(jsRunElement);
          }, 300);
        };

        runByLoginControl(
          () => runGame(true),
          () => runGame(false)
        );
      });

      document.querySelector('#gameContainer img').src = thumbsnailSrc + '/' + gameObj.id + '.jpg';
    } else {
      //initGameIframe(gameObj.id);
      /*const moduleBasicFunc = await import('../tools/basic-functions.js');
            let gameDemoWrapper = document.querySelector('.game-demo'),
                runRealGame = document.querySelector('.game-real');
            gameDemoWrapper.setAttribute('data-game-id', gameObj.id);
            runRealGame.setAttribute('data-game-id', gameObj.id);
            gamesThumbnailsLoadedEvent();
            */
      let gameDemoWrapper = document.querySelector('.game-demo');
      gameDemoWrapper.setAttribute('data-game-id', gameObj.id);
      setTimeout(() => {
        const runGame = (isLogged) => {
          const jsRunElement = gameDemoWrapper.querySelector('#game');
          if (isLogged) {
            jsRunElement.classList.remove('js-run-demo');
            jsRunElement.classList.add('js-run-game');
          }
          simulateClick(jsRunElement);
        };
        runByLoginControl(
          () => runGame(true),
          () => runGame(false)
        );
      }, 800);
    }
  } else {
    if (gameUrl == 'book-of-ra-classic') {
      let langLocale = _CMS_LOCALE != '' ? _CMS_LOCALE : _CMS_LANGUAGE;
      window.location.href = window.location.origin + '/' + langLocale + '/slots/book-of-dead';
    }
    let gameArea = document.getElementById('game'),
      gameUnavailableTranslation = await getTranslation('game_unavailable');
    if (gameArea) {
      gameArea.style.width = (gameArea.clientHeight * 16) / 9 + 'px';
      gameArea.classList.add('unavailable');
      gameArea.innerHTML = '<p class="game-unavailable-error">' + gameUnavailableTranslation + '</p>';
    }
  }

  if (document.querySelector('.js-game-description-by-slug')) {
    document.querySelector('.js-game-title').textContent = gameObj?.name || (await getTranslation('game_unavailable'));
  }
  initTags(gameObj?.tags, getCategoryFromUrl(), document.querySelector('.tags'));
}

function getUrlLastSegment() {
  var url = document.URL;
  var lastSegment = url.substring(url.lastIndexOf('/') + 1);
  lastSegment = lastSegment.replace('#', '');
  return lastSegment;
}

/**
 * Returns segment after User language e.q. slots
 */
function getCategoryFromUrl() {
  var url = window.location.pathname;
  var urlSplit = url.split('/');
  return urlSplit[2];
}

const createEL = (domstring) => {
  const html = new DOMParser().parseFromString(domstring, 'text/html');
  return html.body.firstChild;
};

export async function resizeGamesTags() {
  var gamesPanelsList = document.querySelectorAll('.js-search-games .panel');
  const { wrapTags } = await import('./utilities');
  for (var i = 0, len = gamesPanelsList.length; i < len; i++) {
    wrapTags(gamesPanelsList[i]);
  }
}

function gamesThumbnailsLoadedEvent() {
  document.dispatchEvent(new CustomEvent('GAMES_THUMBNAILS_LOADED'));
}

export async function initUpdateGames() {
  const { checkLocalStorage } = await import('../tools/basic-functions');
  const localStorageGC = _CMS_USERIP + '-gamesCollectionsD',
    localStorageG = _CMS_USERIP + '-allGamesD';

  setTimeout(async () => {
    if (!(checkLocalStorage(localStorageGC, 5) && checkLocalStorage(localStorageG, 5))) {
      const { getAllGames, getGamesCollections } = await import('./get-all-games');
      getAllGames(true);
      getGamesCollections(true);
    }
  }, 3 * 1000);
}
